import common from '../../../common';

export const canManageDataTargets = (user) => !!(
   user && common.security.permissions.isProtected('MANAGE_DATA_DESTINATIONS') &&
   user.can && user.can('MANAGE_DATA_DESTINATIONS')
);
